"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareSession = prepareSession;
exports.squareCapture = squareCapture;
exports.validateFlywirePayment = validateFlywirePayment;
exports.validatePhoneNumber = validatePhoneNumber;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _superagent = _interopRequireDefault(require("superagent/dist/superagent.min"));
var _getErrorMessage = _interopRequireDefault(require("@htmniseko/htm-helpers/api/getErrorMessage"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null == arguments[r] ? {} : arguments[r]; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function request(configs, callback) {
  var tenantId = configs.tenantId,
    url = configs.url,
    method = configs.method,
    params = configs.params,
    locale = configs.locale,
    provider = configs.provider,
    env = configs.env,
    guestSource = configs.guestSource,
    guestId = configs.guestId;
  if (env === 'ci' || process.env.NODE_ENV === 'ci') return void 0, void callback(null, {
    body: {
      token: 'TEST'
    }
  });
  var request = _superagent["default"][method](url);
  guestSource && request.set('g-source', guestSource), guestId && request.set('g-id', guestId), tenantId && request.set('X-Tenant', tenantId), provider && request.set('paymentsrv', provider), request.set('Content-Type', 'application/json'), request.set('Accept-Language', locale), request.send(params), request.end(function (err, res) {
    return callback(err, res);
  });
}
function prepareSession(configs, callback) {
  var configClone = _objectSpread({}, configs);
  request(configClone, function (err) {
    var _res$body;
    var res = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (err) {
      var response = err.response,
        message = err.message;
      if (response) {
        var _response$body;
        var respMessage = (response === null || response === void 0 || (_response$body = response.body) === null || _response$body === void 0 || (_response$body = _response$body.error) === null || _response$body === void 0 ? void 0 : _response$body.message) || null;
        if (respMessage) return void callback({
          message: respMessage
        });
      }
      if (message) return void callback({
        message: message
      });
    }
    return (_res$body = res.body) !== null && _res$body !== void 0 && _res$body.token ? void callback(null, res.body) : void callback({
      message: 'Missing token from the prepareSession response!'
    });
  });
}
function squareCapture(configs, callback) {
  request(configs, function (err, res) {
    if (err) {
      var _res$body2;
      var error = (0, _getErrorMessage["default"])((_res$body2 = res.body) === null || _res$body2 === void 0 ? void 0 : _res$body2.error);
      return void callback(error);
    }
    callback(null, res.body);
  });
}
function validateFlywirePayment(configs, callback) {
  request(configs, function (err, res) {
    return err ? void callback(err) : void callback(null, res.body);
  });
}
function validatePhoneNumber(_x) {
  return _validatePhoneNumber.apply(this, arguments);
}
function _validatePhoneNumber() {
  return _validatePhoneNumber = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(configs) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      for (; 1;) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            request(configs, function (err, res) {
              if (err) {
                var _res$body3;
                var error = (0, _getErrorMessage["default"])((_res$body3 = res.body) === null || _res$body3 === void 0 ? void 0 : _res$body3.error);
                reject(error);
              } else resolve(res.body);
            });
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), _validatePhoneNumber.apply(this, arguments);
}